import { render, staticRenderFns } from "./RouteButton.vue?vue&type=template&id=56de9a61&"
import script from "./RouteButton.vue?vue&type=script&lang=ts&"
export * from "./RouteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports